import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';
import { ConsentType } from '../../global-data-models/user.model';

export type ConsentData = Record<ConsentType, boolean>;

@Component({
    selector: 'app-global-consent-form',
    imports: [...COMMON_IMPORTS],
    templateUrl: "./global-consent-form.component.html"
})
export class GlobalConsentFormComponent {
  @Input() enableDataConsent: boolean = true;

  public formGroup: FormGroup;

  constructor(private fb: FormBuilder) {
    this.formGroup = this.fb.group({
      data: [false, Validators.requiredTrue],
      /* optional consents */
      marketing: [false],
      analytics: [false],
    });

    if (!this.enableDataConsent) {
      this.formGroup.get("data")?.disable();
    }
  }

  public getConsentData(): ConsentData {
    const formData = this.formGroup.getRawValue();
    return {
        DATA: formData.data,
        MARKETING: formData.marketing,
        ANALYTICS: formData.analytics
    }
  }
}
